"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const connect_js_1 = __importDefault(require("@mono.co/connect.js"));
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_i18next_1 = require("react-i18next");
const analytics_1 = require("../../utils/analytics/analytics");
const providerCard_1 = __importDefault(require("../providerCard/providerCard"));
const constants_1 = require("../../constants/constants");
const store_1 = require("../../store");
const config_1 = require("../../../web/config");
const monoCardUtils_1 = require("./monoCardUtils");
const text_1 = __importStar(require("../text/text"));
const logoMono = require('../../assets/images/logo-mono.png');
const MonoCard = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const dispatch = (0, store_1.useAppDispatch)();
    const { logEventWithExtraProperties } = (0, analytics_1.useAnalytics)();
    const status = (0, store_1.useAppSelector)((state) => state.home.financial_data ? state.home.financial_data.provider_status : constants_1.EMPTY);
    const monoInstance = new connect_js_1.default({
        onClose: () => {
            logEventWithExtraProperties('tap_event', {
                name: 'start_mono_widget',
                status: 'closed',
            });
        },
        onLoad: () => {
            logEventWithExtraProperties('tap_event', {
                name: 'start_mono_widget',
                status: 'loaded',
            });
        },
        onSuccess: ({ code }) => {
            logEventWithExtraProperties('tap_event', {
                name: 'start_mono_widget',
                status: 'success',
            });
            (0, monoCardUtils_1.submitForm)(code, dispatch, undefined, logEventWithExtraProperties);
        },
        key: config_1.MONO_KEY,
    });
    monoInstance.setup();
    const monoConnectOpen = () => {
        logEventWithExtraProperties('tap_event', {
            name: 'connect_bank_account',
            provider: 'mono',
        });
        monoInstance.open(); // nosemgrep
    };
    if (status === constants_1.MATCH) {
        return (react_1.default.createElement(providerCard_1.default, { onPress: () => null, logo: react_1.default.createElement(react_native_1.Image, { source: logoMono }), isConnected: true, eventName: "mono_card_matched" }));
    }
    return (react_1.default.createElement(providerCard_1.default, { onPress: monoConnectOpen, logo: react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_TITLE, style: { fontWeight: 'bold' } }, t('statementProvider.mono'))), 
        // DOENS'T WORK ON CHROME
        // logo={
        //     <Image
        //         source={logoMono}
        //         style={[
        //             {
        //                 flex: 1,
        //                 aspectRatio: 2.7,
        //                 resizeMode: 'contain',
        //             },
        //         ]}
        //     />
        // }
        isConnected: false, eventName: "mono_card_no_matched_empty" }));
};
exports.default = MonoCard;
